"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DatePickerMonthSelector = void 0;
var _react = _interopRequireDefault(require("react"));
var _StyledComponent = require("../StyledComponent.js");
var _Typography = require("../../../Typography/index.js");
var _images = require("../../../DatePickerInput/assets/images.js");
var _jsxRuntime = require("react/jsx-runtime");
const MonthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const DatePickerMonthSelector = props => {
  const MONTHS_IN_ROW = 3;
  const {
    textColor,
    selectedColor,
    selectedBg,
    setShowDateSelector,
    setCurrentYearMonth,
    currentYearMonth,
    maxDate,
    disabledDaysColor,
    borderRadius,
    monthFontFamily,
    monthFontStyle,
    monthFontWeight,
    monthFontSize,
    monthTransformation,
    monthDecoration,
    monthTextColor,
    hoverMonthTextColor,
    hoverMonthBgColor,
    currentMonthBgColor,
    currentMonthBorderRadius,
    currentMonthBorderWidth,
    currentMonthBorderStyle,
    currentMonthBorderColor,
    currentMonthBoxShadow,
    currentMonthFontFamily,
    currentMonthFontStyle,
    currentMonthFontWeight,
    currentMonthFontSize,
    currentMonthTransformation,
    currentMonthDecoration,
    currentMonthTextColor,
    selectedMonthBgColor,
    selectedMonthBorderRadius,
    selectedMonthBorderWidth,
    selectedMonthBorderStyle,
    selectedMonthBorderColor,
    selectedMonthBoxShadow,
    selectedMonthFontFamily,
    selectedMonthFontStyle,
    selectedMonthFontWeight,
    selectedMonthFontSize,
    selectedMonthTransformation,
    selectedMonthDecoration,
    selectedMonthTextColor
  } = props;
  const addMonthCol = col => {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_StyledComponent.StyledRow, {
      className: "mun-date-picker-month__row",
      children: col
    });
  };
  const handleMonthSelection = index => {
    setCurrentYearMonth(prevState => {
      return new Date(prevState.setMonth(index));
    });
    handleBackClick();
  };
  const handleBackClick = () => {
    setShowDateSelector();
  };
  const getDisabledIndex = () => {
    if (!maxDate || !currentYearMonth) return 12;
    if (currentYearMonth.getFullYear() > maxDate.getFullYear()) return 0;
    if (maxDate.getFullYear() === currentYearMonth.getFullYear() && maxDate.getMonth() > currentYearMonth.getMonth() + 1) {
      return maxDate.getMonth() + 1;
    }
    return 12;
  };
  const todayValue = new Date();
  const currentMonth = todayValue.getMonth();
  const getMonthContainer = (monthName, index, selected, disabled) => {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_StyledComponent.StyledCol, {
      className: "mun-date-picker-month__col",
      textColor: monthTextColor ?? textColor,
      selectedColor: selectedMonthTextColor || selectedColor,
      selectedBg: selectedMonthBgColor || selectedBg,
      isSelected: selected,
      disabled: disabled,
      disabledDaysColor: disabledDaysColor,
      borderRadius: borderRadius,
      isCurrent: currentMonth === index,
      fontFamily: monthFontFamily,
      fontStyle: monthFontStyle,
      fontWeight: monthFontWeight,
      fontSize: monthFontSize,
      transformation: monthTransformation,
      decoration: monthDecoration,
      onHoverTextColor: hoverMonthTextColor,
      onHoverBgColor: hoverMonthBgColor,
      currentBgColor: currentMonthBgColor,
      currentBorderRadius: currentMonthBorderRadius,
      currentBorderWidth: currentMonthBorderWidth,
      currentBorderStyle: currentMonthBorderStyle,
      currentBorderColor: currentMonthBorderColor,
      currentBoxShadow: currentMonthBoxShadow,
      currentFontFamily: currentMonthFontFamily,
      currentFontStyle: currentMonthFontStyle,
      currentFontWeight: currentMonthFontWeight,
      currentFontSize: currentMonthFontSize,
      currentTransformation: currentMonthTransformation,
      currentDecoration: currentMonthDecoration,
      currentTextColor: currentMonthTextColor,
      selectedBorderRadius: selectedMonthBorderRadius,
      selectedBorderWidth: selectedMonthBorderWidth,
      selectedBorderStyle: selectedMonthBorderStyle,
      selectedBorderColor: selectedMonthBorderColor,
      selectedBoxShadow: selectedMonthBoxShadow,
      selectedFontFamily: selectedMonthFontFamily,
      selectedFontStyle: selectedMonthFontStyle,
      selectedFontWeight: selectedMonthFontWeight,
      selectedFontSize: selectedMonthFontSize,
      selectedTransformation: selectedMonthTransformation,
      selectedDecoration: selectedMonthDecoration,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_StyledComponent.StyledTypography, {
        variant: _Typography.typographyVariantEnum.captionSemiBold,
        onClick: () => !disabled && handleMonthSelection(index),
        children: monthName
      })
    });
  };
  const getMonths = () => {
    let monthsDiv = [];
    let col = [];
    const disableFromMonth = getDisabledIndex();
    const selected = new Date(currentYearMonth).getMonth();
    MonthNames.forEach((monthName, index) => {
      const disabled = index >= disableFromMonth;
      const selectedIndex = !disabled && selected === index;
      col.push(getMonthContainer(monthName, index, selectedIndex, disabled));
      if ((index + 1) % MONTHS_IN_ROW === 0) {
        monthsDiv.push(addMonthCol(col));
        col = [];
      }
    });
    if (col.length > 0) {
      monthsDiv.push(addMonthCol(col));
    }
    return monthsDiv;
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_StyledComponent.StyledMonthSelector, {
    className: "mun-date-picker-month",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_StyledComponent.StyledSvgIconContainer, {
      onClick: handleBackClick,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_StyledComponent.StyledSvgIcon, {
        className: 'mun-date-picker-month__icon',
        url: _images.DatePickerLeftIcon,
        fillColor: textColor,
        fillHoverColor: selectedColor
      })
    }), getMonths()]
  });
};
exports.DatePickerMonthSelector = DatePickerMonthSelector;
var _default = exports.default = DatePickerMonthSelector;